module.exports = __webpack_public_path__ + "static/media/12.1f0582a7.jpg";